import React from 'react'
import { connect } from 'react-redux';

import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import Form from './components/Form'
import { getRedirectUrlReference } from './reducers'

import { loanApplicationFetchStart } from './actions';

class Main extends React.Component {

  componentDidMount() {
    this.props.loanApplicationFetchStart({id: this.props.loanApplicationId})
  }

  componentWillReceiveProps(nextProps) {
    const redirectUrl = nextProps.getRedirectUrlReference
    if (redirectUrl && Object.keys(redirectUrl).length != 0) {
      window.location.href = redirectUrl.url
    }
  }

  render() {
    return(
      <div>
        <Navbar logoUrl={ gon.assets.navbarLogoUrl } />
        <Sidebar />
        <Form />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  getRedirectUrlReference: getRedirectUrlReference(state),
});

export default connect(mapStateToProps, {
  loanApplicationFetchStart
})(Main);
